import { axiosInstance as axios } from '../../boot/axios-file'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    //下载文件
    DownloadFile({ commit, rootGetters }, request) {
      return axios
        .post('/api/File/DownloadFile', { ...request }, { responseType: 'blob' })
        .then((response) => {
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    //no Token
    async NoAuthDownloadFile({ commit, rootGetters }, request) {
      return axios
        .post('/api/file/NoAuthDownloadFile', { ...request }, { responseType: 'blob', headers: { APIkey: 'www.lncmac.com.tw' } })
        .then((response) => {
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    async UploadImageFile({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)
      return axios
        .post('/api/file/UploadImageFile', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    async UploadAbnormalImageFile({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)
      return axios
        .post('/api/file/UploadAbnormalImageFile', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    async Upload({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)
      return axios
        .post('/api/file/UploadFileResponseUrlTo', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    async UploadRobot({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)
      return axios
        .post('/api/file/UploadRobotSpecificationFile', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetFilesZip({ rootGetters }, request) {
      return axios
        .post('/api/file/GetFilesZip', {
          ...request
        })
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject('發生錯誤')
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    UploadDesignerCaseImageFile({ commit, rootGetters }, request) {
      const formData = new FormData()
      formData.append('File', request.File)
      return axios
        .post('/api/file/UploadDesignerCaseImageFile', formData)
        .then((response) => {
          if (response.data.code === 200) {
            return Promise.resolve(response.data)
          } else {
            return Promise.reject(response.data.Values.Message)
          }
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },
    GetPictureData({ commit, rootGetters }, request) {
      return axios
        .get(`/api/file/GetPictureData?imagePath=${request.imagePath}`)
        .then((response) => {
          if (response.data.code === 200) {
            return response.data
          } else {
            throw new Error('發生錯誤')
          }
        })
        .catch((error) => {
          throw error
        })
    }
  }
}
